module.exports = __webpack_public_path__ + "img/img4.ca3f81a7.png";